import { render, staticRenderFns } from "./register.vue?vue&type=template&id=fb0d8708&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./login.css?vue&type=style&index=0&id=fb0d8708&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d8708",
  null
  
)

export default component.exports